import { Component } from '@angular/core';

@Component({
  selector: 'app-b2c-login',
  templateUrl: './b2c-login.html',
})
export class B2cLoginComponent {
  constructor() {}
}
